<template>
  <div>
    <div class="ticket">
      <div class="left-container">
        <img
          class="left-logo"
          src="../../../public/assets/CoreEvent-logo-black.svg"
          alt="CoreEvent-logo"
        >
        <div class="about-left">
          <p>
            <b>Ovo nije ulaznica.</b><br>
            Not a ticket.
          </p>
        </div>
      </div>
      <div class="right-container">
        <div class="about-right">
          <p>
            <b>Ovo nije ulaznica.</b><br>
            Not a ticket.
          </p>
        </div>
      </div>
    </div>
    <div v-if="isLast" class="tearOffWrapper" />
  </div>
</template>

<script>
export default {
  name: 'not-a-ticket',
  props: ['isLast'],
}
</script>

<style scoped>
.ticket {
  display: flex;
  flex-direction: row;
  height: 70mm;
  width: 210mm;
}
.left-container {
  height: 100%;
  width: calc(210mm * 0.8);
  padding: 4mm 0 0 14mm;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.left-logo {
  height: 55mm;
  width: 45mm;
  align-self: center;
  margin-right: 18px;
}
.about-left {
  align-self: center;
  font-family: 'Raleway';
  font-style: normal;
  font-size: 19px;
  line-height: 108%;
  letter-spacing: -0.03em;
  color: #333333;
}
.right-container {
  background: white;
  height: 100%;
  width: calc(210mm * (0.2));
  display: flex;
  flex-direction: column;
  writing-mode: vertical-rl;
  align-items: flex-end;
  transform: rotate(-180deg);
}
.about-right {
  font-family: 'Raleway';
  font-style: normal;
  font-size: 13px;
  line-height: 108%;
  letter-spacing: -0.03em;
  color: #333333;
  transform: translateX(-250%);
  align-self: flex-start;
  margin-right: 20px;
  margin-top: 30px;
}
.tearOffWrapper {
  height: 26px;
  width: 210mm;
  display: flex;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 400;
  font-size: 8px;
  line-height: 9px;
  color: #000;
}
.tearOff {
  margin-left: 90mm;
  margin-top: 10px;
}
</style>
